import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import Header from "@/components/Header";
import api from "@/lib/api";
import { FileText, Paperclip, Image as ImageIcon } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

const HistoryPage = () => {
  const { language, user, authLoading } = useApp();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (authLoading) return;
    if (!user) { navigate("/login"); return; }
    api.get("/complaints").then((r) => setItems(r.data)).catch(() => {});
  }, [user, authLoading, navigate]);

  const lang = language || "en";
  const labelMap = { gaca: "GACA · Air", cst: "CST · Telecom", tga: "TGA · Delivery" };

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Header />
      <main className="max-w-5xl mx-auto px-6 py-10">
        <h1 className="text-3xl font-bold text-slate-900 mb-6 text-start">
          {lang === "ar" ? "شكاواي" : "My complaints"}
        </h1>
        {items.length === 0 ? (
          <div className="bg-white border border-slate-200 rounded-2xl p-10 text-center text-slate-500">
            <FileText className="h-10 w-10 text-slate-300 mx-auto mb-3" />
            {lang === "ar" ? "لا توجد شكاوى محفوظة بعد." : "No saved complaints yet."}
          </div>
        ) : (
          <div className="space-y-4">
            {items.map((c) => (
              <div key={c.id} className="bg-white border border-slate-200 rounded-2xl p-6" data-testid={`history-item-${c.id}`}>
                <div className="flex items-center justify-between mb-3">
                  <span className="text-xs font-medium uppercase tracking-wide text-[#C5A059]">
                    {labelMap[c.category]}
                  </span>
                  <span className="text-xs text-slate-400">{new Date(c.created_at).toLocaleString()}</span>
                </div>
                <p
                  className="text-sm text-slate-700 whitespace-pre-wrap max-h-40 overflow-hidden text-start"
                  dir={c.language === "ar" ? "rtl" : "ltr"}
                >
                  {c.refined_text}
                </p>
                {c.attachments && c.attachments.length > 0 && (
                  <div className="mt-4 pt-4 border-t border-slate-100 flex flex-wrap items-center gap-2" data-testid={`history-attachments-${c.id}`}>
                    <Paperclip className="h-3.5 w-3.5 text-slate-400" />
                    {c.attachments.map((a) => {
                      const isImage = a.content_type?.startsWith("image/");
                      const Icon = isImage ? ImageIcon : FileText;
                      return (
                        <a
                          key={a.id}
                          href={`${API}/api/files/${a.id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center gap-1.5 text-xs text-[#006C35] hover:underline bg-[#006C35]/5 hover:bg-[#006C35]/10 px-2.5 py-1 rounded-md"
                        >
                          <Icon className="h-3 w-3" />
                          <span className="truncate max-w-[180px]">{a.filename}</span>
                        </a>
                      );
                    })}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default HistoryPage;
